import { useState, useEffect, useRef } from 'react';

export default function Categories() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  const categories = [
    {
      title: 'مجوهرات تكمل حضورك',
      image: 'https://public.readdy.ai/ai/img_res/a44ce1e604513a18d909f94628b5c8a8.jpg',
      description: 'قطع مختارة بعناية لتضيف لمسة من الأناقة'
    },
    {
      title: 'اختياراتي من الشنط',
      image: 'https://readdy.ai/api/search-image?query=Designer%20luxury%20handbags%20collection%20featuring%20elegant%20leather%20bags%20in%20beige%20and%20champagne%20tones%20on%20marble%20surface%2C%20soft%20studio%20lighting%2C%20high-end%20fashion%20photography%2C%20minimalist%20aesthetic%2C%20premium%20quality%2C%20refined%20presentation%2C%20sophisticated%20styling%2C%20boutique%20display&width=600&height=700&seq=cat-bags-maram-002&orientation=portrait',
      description: 'شنط فاخرة تناسب كل مناسبة'
    },
    {
      title: 'قطع تعيش معك',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20lifestyle%20accessories%20including%20elegant%20watches%2C%20designer%20sunglasses%2C%20and%20premium%20leather%20goods%20on%20soft%20taupe%20background%2C%20warm%20golden%20hour%20lighting%2C%20professional%20product%20photography%2C%20minimalist%20composition%2C%20high-end%20quality%2C%20refined%20details%2C%20sophisticated%20presentation&width=600&height=700&seq=cat-accessories-maram-003&orientation=portrait',
      description: 'إكسسوارات تدوم وتبقى معك'
    },
    {
      title: 'اكتشفي اختياراتي من الملابس',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20designer%20clothing%20collection%20with%20luxury%20dresses%20and%20sophisticated%20outfits%20in%20neutral%20beige%20and%20champagne%20colors%2C%20boutique%20interior%20setting%2C%20soft%20natural%20lighting%2C%20high-end%20fashion%20photography%2C%20minimalist%20styling%2C%20premium%20quality%2C%20refined%20presentation%2C%20luxurious%20fabric%20textures&width=600&height=700&seq=cat-clothing-maram-004&orientation=portrait',
      description: 'أزياء راقية تعكس ذوقك الرفيع'
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="categories" className="py-20 px-6 bg-[#F8F6F0]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 
            className={`text-4xl md:text-5xl font-bold text-[#C9A88A] mb-4 transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            الأقسام الرئيسية
          </h2>
          <div 
            className={`w-24 h-1 bg-[#D4AF7A] mx-auto transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
            }`}
          ></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category, index) => (
            <div
              key={index}
              className={`group cursor-pointer rounded-2xl overflow-hidden bg-white shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="relative w-full h-80 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#3D3D3D] mb-2 group-hover:text-[#C9A88A] transition-colors">
                  {category.title}
                </h3>
                <p className="text-[#3D3D3D]/70 text-sm leading-relaxed">
                  {category.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
